import EstadoService from "@/services/EstadoService";

export const actions = {
  async listarEstados({ commit }) {
    await EstadoService.listar()
      .then((res) => {
        commit("setEstados", res.data);
      })
      .catch((e) => console.log(e));
  },
};

export default {};
